import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';
import { withTranslation } from 'react-i18next';
import { get, set } from '@totalsoft/change-tracking-react';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import PhoneNumberField from 'components/common/inputs/PhoneNumberTextField';

const SimulatorPJClientComponent = ({ t, partnerLens, validation, editPartnerDisabled }) => {
  const generalData = useMemo(() => partnerLens.generalData, [partnerLens.generalData]);
  const contactData = useMemo(() => partnerLens.contactData, [partnerLens.contactData]);

  return (
    <>
      <Grid item xs={12} sm={6}></Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          value={generalData.uniqueId |> get}
          name='uniqueId'
          label={t('Simulator.Client.PJ.PersonalIdentifier')}
          onChange={generalData.uniqueId |> set}
          error={!isValid(validation.generalData.uniqueId)}
          helperText={getErrors(validation.generalData.uniqueId)}
          disabled={editPartnerDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          value={generalData.partnerName |> get}
          name='partnerName'
          label={t('Simulator.Client.CompanyName')}
          onChange={generalData.partnerName |> set}
          error={!isValid(validation.generalData.partnerName)}
          helperText={getErrors(validation.generalData.partnerName)}
          disabled={editPartnerDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          value={contactData.personName |> get}
          name='personName'
          label={t('Simulator.Client.PersonName')}
          onChange={contactData.personName |> set}
          disabled={editPartnerDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <PhoneNumberField
          sx={{
            '& .MuiInput-input': {
              padding: '2px'
            }
          }}
          fullWidth
          variant='standard'
          size='small'
          value={contactData.phone |> get}
          name='phone'
          label={t('Simulator.Client.MobilePhone')}
          onChange={contactData.phone |> set}
          error={!isValid(validation.contactData.phone)}
          helperText={getErrors(validation.contactData.phone)}
          disabled={editPartnerDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          value={contactData.email |> get}
          name='email'
          label={t('Simulator.Client.Email')}
          onChange={contactData.email |> set}
          error={!isValid(validation.contactData.email)}
          helperText={getErrors(validation.contactData.email)}
          disabled={editPartnerDisabled}
        />
      </Grid>
    </>
  );
};
SimulatorPJClientComponent.propTypes = {
  t: PropTypes.func.isRequired,
  partnerLens: PropTypes.object.isRequired,
  validation: PropTypes.object.isRequired,
  editPartnerDisabled: PropTypes.bool.isRequired
};
export default withTranslation()(SimulatorPJClientComponent);
